import { BoolRadioField } from '@views/register/history/history-fields';
import type { TLocalize } from '@hooks/use-localize';
import type { IHistorySocialModel } from '@/types/history/history-social';

interface IProps {
    model: IHistorySocialModel;
    t: TLocalize;
}

/** The sexual-social risk questions, shown only when the intake config asks for them. */
const RiskQuestionsSection = ({ model, t }: IProps) => {
    const yes = t('Word_Yes', 'Yes');
    const no = t('Word_No', 'No');

    return (
        <>
            <BoolRadioField
                name="hasHadHighRiskSex"
                label={t('DashLabel_InTheLast12MonthsHaveYouHadSexWithSomeoneWhoHasHiv', 'In the last 30 days have you had sex with someone who has HIV, Hepatitis B, or Hepatitis C, or may be at increased risk for one of these infections')}
                yesLabel={yes}
                noLabel={no}
            />

            {model.isFemale ? (
                <BoolRadioField
                    name="hasHadSexWithMmRelationsMale"
                    label={t('DashLabel_InTheLast12MonthsHaveYouHadSexWithAMaleWhoHasHadAS', 'In the last 30 days have you had sex with a male who has had a sexual contact with another male')}
                    yesLabel={yes}
                    noLabel={no}
                />
            ) : (
                <BoolRadioField
                    name="hasHadMmSex"
                    label={t('DashLabel_InTheLast12MonthsHaveYouHadSexWithAnotherMale', 'In the last 30 days have you had sex with another male')}
                    yesLabel={yes}
                    noLabel={no}
                />
            )}

            <BoolRadioField
                name="hasHadSexWithProstitute"
                label={t('DashLabel_InTheLast12MonthsHaveYouHadSexWithAProstituteOrAny', 'In the last 30 days have you had sex with a prostitute or anyone else who takes money, drugs, or other payment for sex')}
                yesLabel={yes}
                noLabel={no}
            />

            <BoolRadioField
                name="hasProstituted"
                label={t('DashLabel_InTheLast12MonthsHaveYouExchangedSexForMoneyOrDrug', 'In the last 30 days have you exchanged sex for money or drugs')}
                yesLabel={yes}
                noLabel={no}
            />

            <BoolRadioField
                name="hasHadSexWithNeedleDrugUser"
                label={t('DashLabel_InTheLast12MonthsHaveYouSexWithSomeoneWhoHasUsedNe', 'In the last 30 days have you had sex with someone who has used needles to take drugs, steroids, or anything not prescribed by the doctor')}
                yesLabel={yes}
                noLabel={no}
            />

            <BoolRadioField
                name="hasUsedNeedleDrugs"
                label={t('DashLabel_InTheLast12MonthsHaveYouUsedNeedlesToTakeDrugsSter', 'In the last 30 days have you used needles to take drugs, steroids, or anything not prescribed by your doctor')}
                yesLabel={yes}
                noLabel={no}
            />

            <BoolRadioField
                name="hasBeenInJailOver72"
                label={t('DashLabel_InTheLast12MonthsHaveYouEverBeenInJailDetentionFor', 'In the last 30 days have you ever been in jail/detention for more than 72 continuous hours')}
                yesLabel={yes}
                noLabel={no}
            />

            <BoolRadioField
                name="hasHadStd"
                label={t('DashLabel_InTheLast12MonthsHaveYouEverBeenDiagnosedWithOrTre', 'In the last 30 days have you ever been diagnosed with or treated for a sexually transmitted infection, such as gonorrhea, chlamydia, syphilis or genital warts')}
                yesLabel={yes}
                noLabel={no}
            />

            <BoolRadioField
                name="hasBeenOnHemodialysis"
                label={t('DashLabel_InTheLast12MonthsHaveYouEverBeenOnHemodialysis', 'In the last 30 days have you ever been on hemodialysis')}
                yesLabel={yes}
                noLabel={no}
            />
        </>
    );
};

export default RiskQuestionsSection;
